export default {
    addresses: [],
    showNewAddress: false,
    search: "",
    loadingAddress: undefined,
    sort: {
        after: "CREATED",
        order: "ASC"
    }
}